import React, { useRef } from "react";
import searchIcon from "../../assets/icons/Search.png";
import filterIcon from "../../assets/icons/filter2.png";

const SearchBar = ({
  searchKeyword,
  setSearchKeyword,
  onSearch,
  onToggleFilter,
  isFocused,
  setIsFocused,
  isMobile = false,
}) => {
  const inputRef = useRef(null);

  const handleSearchIconClick = (e) => {
    e.stopPropagation();
    onSearch({ preventDefault: () => {} });
  };

  return (
    <form
      onSubmit={onSearch}
      className={`flex items-center gap-1 sm:gap-2 w-full lg:w-[450px] xl:w-[595px] h-[36px] sm:h-[38px] lg:h-[42px] ${isMobile?"":"bg-[#1E1E1E] rounded-[5px]"} `}
      data-testid={`search-form-${isMobile ? "mobile" : "desktop"}`}
    >
      <div
        className={`p-[1px] rounded-[8px] sm:rounded-[10px] lg:rounded-[12px] flex-grow transition-all duration-300 ${
          isFocused
            ? "bg-gradient-to-b from-[#52FAF0] via-[#36BAE0] to-[#197AD0]"
            : "bg-[#1E1E1E]"
        }`}
        onClick={() => inputRef.current?.focus()}
      >
        <div className="flex items-center bg-[#1E1E1E] rounded-[8px] sm:rounded-[10px] lg:rounded-[12px] px-4 py-[6px] sm:py-[8px] lg:py-[10px] w-full h-full">
          {/* Search Icon */}
          <svg
            width="14"
            height="14"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px] lg:w-[18px] lg:h-[18px] opacity-60 mr-1.5 sm:mr-2 cursor-pointer"
            onClick={handleSearchIconClick}
          >
            <path
              d="M8.25 15C10.0402 15 11.7571 14.2888 13.023 13.023C14.2888 11.7571 15 10.0402 15 8.25C15 6.45979 14.2888 4.7429 13.023 3.47703C11.7571 2.21116 10.0402 1.5 8.25 1.5C6.45979 1.5 4.7429 2.21116 3.47703 3.47703C2.21116 4.7429 1.5 6.45979 1.5 8.25C1.5 10.0402 2.21116 11.7571 3.47703 13.023C4.7429 14.2888 6.45979 15 8.25 15ZM14.1975 15.5175C14.595 16.7175 15.5025 16.8375 16.2 15.7875C16.8375 14.8275 16.4175 14.04 15.2625 14.04C14.4075 14.0325 13.9275 14.7 14.1975 15.5175Z"
              stroke="#AAAAAA"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <div className="relative flex-grow flex items-center w-full">
            {!searchKeyword && (
              <span
                translate="no"
                className="notranslate absolute left-0 text-[#828282] text-xs sm:text-sm lg:text-sm pointer-events-none select-none"
              >
                Search by artist, title, or remixer
              </span>
            )}
            <input
              ref={inputRef}
              type="text"
              translate="no"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              onKeyDown={(e) => {
                if (e.key === "Escape") setSearchKeyword("");
                else if (e.key === "Enter") {
                  e.preventDefault();
                  onSearch(e);
                }
              }}
              className="bg-transparent text-[#828282] text-xs sm:text-sm lg:text-sm w-full outline-none notranslate relative z-10"
            />
          </div>
        </div>
      </div>

      {/* Filter Button - Hidden on mobile, shown on larger screens */}
      <div
        onClick={onToggleFilter}
        className="w-[36px] h-[36px] sm:w-[38px] sm:h-[38px] lg:w-[42px] lg:h-[42px] rounded-[8px] sm:rounded-[10px] lg:rounded-[12px] bg-[#383838] items-center justify-center cursor-pointer hover:bg-[#1E1E1E] transition-all duration-300 hidden lg:flex"
      >
        {/* Filter icon */}
        <svg
          width="16"
          height="16"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px] lg:w-[18px] lg:h-[18px]"
        >
          <path
            d="M10.7399 14.3023C10.7399 14.7598 10.4399 15.3598 10.0574 15.5923L8.99992 16.2748C8.01742 16.8823 6.65242 16.1998 6.65242 14.9848V10.9723C6.65242 10.4398 6.35242 9.75732 6.04492 9.38232L3.16492 6.35232C2.78242 5.96982 2.48242 5.29482 2.48242 4.83732V3.09732C2.48242 2.18982 3.16492 1.50732 3.99742 1.50732H14.0024C14.8349 1.50732 15.5174 2.18982 15.5174 3.02232V4.68732C15.5174 5.29482 15.1349 6.05232 14.7599 6.42732"
            stroke="white"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.9023 12.8398L14.1523 12.0898M12.0523 12.3898C12.6889 12.3898 13.2993 12.137 13.7494 11.6869C14.1995 11.2368 14.4523 10.6264 14.4523 9.98984C14.4523 9.35332 14.1995 8.74288 13.7494 8.29279C13.2993 7.8427 12.6889 7.58984 12.0523 7.58984C11.4158 7.58984 10.8054 7.8427 10.3553 8.29279C9.9052 8.74288 9.65234 9.35332 9.65234 9.98984C9.65234 10.6264 9.9052 11.2368 10.3553 11.6869C10.8054 12.137 11.4158 12.3898 12.0523 12.3898Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      
      <button type="submit" className="hidden">
        Search
      </button>
    </form>
    
  );
};

export default SearchBar;